// extracted by mini-css-extract-plugin
export default {"body-home":"camouflage_body-home__8GOxk","camouflage":"camouflage_camouflage__reVY5","reflection":"camouflage_reflection__iyqCe","loading":"camouflage_loading__VXj3W"};